import { PanelFrame } from './floating';

const GROUPS: [string, [string, string][]][] = [
  [
    'Navigate',
    [
      ['Wheel / pinch', 'Zoom at the cursor'],
      ['Shift + wheel', 'Pan'],
      ['Space + drag, middle drag, H', 'Pan'],
      ['+ / - / 0', 'Zoom in / out / 100%'],
      ['1 / 2', 'Fit all / fit selection'],
      ['Tab', 'Hide the interface, or show it again (also the eye in the view bar)'],
    ],
  ],
  [
    'Create',
    [
      ['N / T / X', 'Sticky note / title / text block'],
      ['Shift+B / D / K', 'Table / to-do list / kanban'],
      ['S', 'Shape (drag; Shift = square)'],
      ['A', 'Arrow / connector: drag from one item to another; the ends stick to them (on a side dot: to that point). Curved ones follow a wavy drag; Alt leaves the ends loose, Shift keeps it unbent'],
      ['F', 'Frame (drag; moving a frame carries its contents)'],
      ['P / U / B', 'Pen (pressure) / fineliner (constant width) / brush pen'],
      ['M / G', 'Highlighter / fill (paints the inside of a drawn loop)'],
      ['E', 'Eraser (partial, or whole strokes: set in the draw options)'],
      ['L', 'Lasso: select strokes (draw a loop; Shift adds; tap picks one)'],
      ['Shift + draw', 'Straight line in 15 degree steps (pausing at the end of a line straightens it too)'],
      ['Alt + click', 'While drawing: take a colour from the board for the pen'],
      ['C', 'Cut out a piece of an image (lasso, rectangle or ellipse; soft edge and hole-in-source options)'],
      ['R', 'Sketch sheet: paint the selected sheet, or place a new one (A4 at 300 dpi by default)'],
      ['I', 'Import images or attach files'],
      ['Ctrl + V', 'Paste at the mouse cursor: items (also from another board, split pane or tab), images, text (note) or a URL (link card; a board link makes a board card)'],
      ['Ctrl + V a list', 'A bullet or numbered list becomes one sticky note per item, in a grid that reads like the list. Selected notes go back with Copy as list in the inspector'],
    ],
  ],
  [
    'Edit',
    [
      ['Double-click', 'Edit text, open link or board card, download file'],
      ['Enter', 'Edit the selected text item'],
      ['Ctrl + Z / Ctrl + Shift + Z', 'Undo / redo'],
      ['Ctrl + C / X / D', 'Copy / cut (works across boards and tabs) / duplicate'],
      ['Delete', 'Delete selection'],
      ['Arrows (+ Shift)', 'Nudge 1 px (10 px)'],
      ['[ / ] and Ctrl + [ / ]', 'Z-order step / to back, to front'],
      ['Ctrl + G / Ctrl + Shift + G', 'Group / ungroup'],
      ['Ctrl + L', 'Lock / unlock'],
      ["'", 'Toggle snapping (hold Alt to bypass)'],
      ['Alt while resizing', 'Free aspect on images'],
      ['Alt + drag (Cmd + drag on a Mac)', 'Drag a copy, leaving the original in place'],
      ['Shift while rotating', 'Snap to 15°'],
      ['Q / Shift + Q', 'Cutout drawer (shared by all your boards) / save the selection in it. Drag items onto the drawer to save them, drag its tiles onto a board to place them'],
      ['J', 'Frame index: every frame by title; click one to fly there, double-click to rename'],
    ],
  ],
  [
    'Paint (on a sketch sheet)',
    [
      ['Double-click a sheet, or Enter', 'Start painting on it'],
      ['P / F / B', 'Pencil (graphite, grain) / fineliner / brush'],
      ['X / T / A', 'Pixel brush (no anti-aliasing) / halftone (dot screen) / spray'],
      ['E / G / I', 'Eraser / fill / eyedropper (Alt + press picks with any brush)'],
      ['L', 'Lasso: select pixels with a loop (a tap drops the selection); brushes and fills stay inside it'],
      ['V', 'Move the selected pixels, or the whole layer (Shift = one axis; arrows nudge 1 px, with Shift 10 px)'],
      ['Ctrl + A / Ctrl + D', 'Select the whole sheet / deselect'],
      ['Delete', 'Clear the selected pixels'],
      ['[ / ]', 'Smaller / larger brush'],
      ['Ctrl + Z / Ctrl + Shift + Z', 'Undo / redo the last stroke (or the last board change, whichever is newer)'],
      ['Esc', 'Drop the pixel selection, then stop painting'],
    ],
  ],
  [
    'Touch',
    [
      ['Two-finger tap', 'Undo'],
      ['Three-finger tap', 'Redo'],
      ['Pinch / two-finger drag', 'Zoom / pan'],
      ['Two-finger twist', 'Rotate the canvas (snaps every 45°)'],
      ['Very fast two-finger pinch', 'Reset rotation and zoom to 100%'],
      ['Tap', 'Select (drag moves a selected item; elsewhere pans)'],
      ['Drag the options title bar', 'Float the tool options anywhere; the dock button puts them back'],
    ],
  ],
  [
    'Select',
    [
      ['Click / Shift + click', 'Select / add or remove'],
      ['Drag on empty canvas', 'Marquee select'],
      ['Ctrl + click', 'Pick one item out of a group'],
      ['Ctrl + A', 'Select all'],
      ['Esc', 'Clear selection; again: back to Select'],
      ['?', 'This list'],
    ],
  ],
];

export function ShortcutsPanel({ onClose }: { onClose: () => void }) {
  return (
    <PanelFrame kind="shortcuts" title="Keyboard shortcuts" className="shortcuts-panel" onClose={onClose}>
      <div className="shortcuts-body">
        {GROUPS.map(([title, rows]) => (
          <section key={title}>
            <div className="insp-label">{title}</div>
            <table className="shortcuts">
              <tbody>
                {rows.map(([keys, what]) => (
                  <tr key={keys}>
                    <td>
                      <kbd>{keys}</kbd>
                    </td>
                    <td>{what}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        ))}
      </div>
    </PanelFrame>
  );
}
